export default function Stat({ stat = '', heading = false }) {
  return (
    <div className="Stat">
      {heading && <p className="text--size-s">{heading}</p>}
      <p className="Stat-value h1">{stat}</p>
    </div>
  );
}
